document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.ppb-buybox').forEach(initBuybox);
});

function initBuybox(root) {
  const money = function (cents) {
    return '$' + (cents / 100).toLocaleString('es-CO', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  };

  function applyBundleDiscount(basePrice, radio) {
    const type = radio && radio.dataset.bundleDiscountType;
    const value = radio ? Number(radio.dataset.bundleDiscountValue) || 0 : 0;
    if (type === 'percent' && value > 0) {
      return Math.round(basePrice - (basePrice * value / 100));
    }
    if (type === 'fixed' && value > 0) {
      return Math.max(0, basePrice - value);
    }
    return basePrice;
  }

  const form = root.querySelector('[data-ppb-form]');
  const variantIdInput = root.querySelector('.ppb-variant-id');
  const quantityInput = root.querySelector('.ppb-quantity-input');
  const variantsDataEl = root.querySelector('.ppb-variants-data');
  const variants = variantsDataEl ? JSON.parse(variantsDataEl.textContent) : [];
  const cta = root.querySelector('.ppb-cta');
  const unavailableMsg = root.querySelector('.ppb-cta__unavailable');

  function findVariant(id) {
    return variants.find(function (v) { return v.id === id; });
  }

  // --- Gallery thumbnails ---
  const mainImg = root.querySelector('.ppb-gallery__main-img');
  root.querySelectorAll('.ppb-gallery__thumb').forEach(function (btn) {
    btn.addEventListener('click', function () {
      root.querySelectorAll('.ppb-gallery__thumb').forEach(function (b) { b.classList.remove('is-active'); });
      btn.classList.add('is-active');
      if (mainImg && btn.dataset.full) mainImg.src = btn.dataset.full;
    });
  });

  // --- Variant / option picker ---
  const optionEls = root.querySelectorAll('.ppb-option');
  const selectedOptions = [];
  optionEls.forEach(function (optionEl) {
    const selectedBtn = optionEl.querySelector('.ppb-option__value.is-selected') || optionEl.querySelector('.ppb-option__value');
    selectedOptions[Number(optionEl.dataset.optionIndex)] = selectedBtn ? selectedBtn.dataset.value : null;
  });

  function matchVariant() {
    return variants.find(function (v) {
      return selectedOptions.every(function (val, i) { return val == null || v.options[i] === val; });
    });
  }

  function updatePriceDisplay(variant) {
    if (!variant) return;
    root.querySelectorAll('.ppb-bundle').forEach(function (bundle) {
      const radio = bundle.querySelector('input[type="radio"]');
      const qty = Number(radio.dataset.quantity) || 1;
      const priceEl = bundle.querySelector('[data-unit-price]');
      const compareEl = bundle.querySelector('[data-unit-compare]');
      const savingsEl = bundle.querySelector('.ppb-bundle__savings');
      const basePrice = variant.price * qty;
      const price = applyBundleDiscount(basePrice, radio);
      let compare = variant.compare_at_price ? variant.compare_at_price * qty : 0;
      if (price < basePrice && basePrice > compare) compare = basePrice;
      if (priceEl) priceEl.textContent = money(price);
      if (compareEl) {
        if (compare > price) {
          compareEl.textContent = money(compare);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      if (savingsEl) {
        if (compare > price) {
          savingsEl.textContent = 'AHORRAS ' + money(compare - price);
          savingsEl.hidden = false;
        } else {
          savingsEl.hidden = true;
        }
      }
    });

    const checkedRadio = root.querySelector('.ppb-bundle input[type="radio"]:checked');
    const checkedQty = checkedRadio ? Number(checkedRadio.dataset.quantity) || 1 : 1;
    syncTopPrice(variant, checkedQty, checkedRadio);
  }

  function syncTopPrice(variant, qty, radio) {
    const currentPriceEl = root.querySelector('.ppb-price-row__current');
    const comparePriceEl = root.querySelector('.ppb-price-row__compare');
    const badgeEl = root.querySelector('.ppb-price-row__badge');
    const stickyBarEl = document.querySelector('.ppb-sticky-bar');
    const stickyPriceEl = stickyBarEl && stickyBarEl.querySelector('.ppb-sticky-bar__price');
    const stickyCompareEl = stickyBarEl && stickyBarEl.querySelector('.ppb-sticky-bar__compare');
    const basePrice = variant.price * qty;
    const price = applyBundleDiscount(basePrice, radio);
    let compare = variant.compare_at_price ? variant.compare_at_price * qty : 0;
    if (price < basePrice && basePrice > compare) compare = basePrice;
    if (currentPriceEl) currentPriceEl.textContent = money(price);
    if (comparePriceEl) {
      comparePriceEl.textContent = compare > price ? money(compare) : '';
      comparePriceEl.style.display = compare > price ? '' : 'none';
    }
    if (badgeEl && compare > price) {
      const pct = Math.round((1 - price / compare) * 100);
      badgeEl.textContent = 'AHORA ' + pct + '%';
    }
    if (stickyPriceEl) stickyPriceEl.textContent = money(price);
    if (stickyCompareEl) stickyCompareEl.textContent = compare > price ? money(compare) : '';
  }

  function updateVariant() {
    const variant = matchVariant();
    if (variantIdInput) {
      variantIdInput.value = variant ? variant.id : '';
      variantIdInput.dispatchEvent(new Event('change', { bubbles: true }));
    }
    const available = !!(variant && variant.available);
    if (cta) cta.disabled = !available;
    if (unavailableMsg) unavailableMsg.hidden = available;
    if (variant) {
      updatePriceDisplay(variant);
      if (mainImg && variant.featured_image && variant.featured_image.src) {
        mainImg.src = variant.featured_image.src.replace(/(\.[a-z]+)(\?|$)/i, '_900x$2');
      }
      if (window.history && window.history.replaceState) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      }
      document.dispatchEvent(new CustomEvent('variant:change', {
        bubbles: true,
        detail: { variant: variant, sectionId: root.dataset.sectionId || '', productId: root.dataset.productHandle || '' }
      }));
      if (form) {
        form.dispatchEvent(new CustomEvent('variant:change', { bubbles: true, detail: { variant: variant } }));
      }
    }
  }

  optionEls.forEach(function (optionEl) {
    const idx = Number(optionEl.dataset.optionIndex);
    optionEl.querySelectorAll('.ppb-option__value').forEach(function (btn) {
      btn.addEventListener('click', function () {
        optionEl.querySelectorAll('.ppb-option__value').forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
        selectedOptions[idx] = btn.dataset.value;
        updateVariant();
      });
    });
  });

  // --- Bundle (quantity) radios ---
  const radios = root.querySelectorAll('.ppb-bundle input[type="radio"]');
  radios.forEach(function (radio) {
    radio.addEventListener('change', function () {
      if (quantityInput) quantityInput.value = radio.dataset.quantity || '1';
      const variant = findVariant(Number(variantIdInput.value)) || matchVariant();
      if (variant) syncTopPrice(variant, Number(radio.dataset.quantity) || 1, radio);
    });
  });
  const checkedRadio = root.querySelector('.ppb-bundle input[type="radio"]:checked');
  if (checkedRadio && quantityInput) quantityInput.value = checkedRadio.dataset.quantity || '1';

  // Initial sync
  updateVariant();

  // --- Add to cart / buy now ---
  if (form) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();
      const variantId = Number(variantIdInput.value);
      if (!variantId) return;
      const quantity = Number(quantityInput.value) || 1;
      const originalText = cta.textContent;
      cta.disabled = true;
      cta.textContent = 'Procesando...';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity: quantity }] })
      })
        .then(function (res) { if (!res.ok) return res.json().then(function (d) { throw d; }); return res.json(); })
        .then(function () { window.location.href = '/checkout'; })
        .catch(function (err) {
          cta.disabled = false;
          cta.textContent = originalText;
          alert((err && err.description) || 'No se pudo agregar el producto. Intenta de nuevo.');
        });
    });
  }

  // --- Delivery timeline dates (ranges, computed from today) ---
  const timeline = root.querySelector('.ppb-timeline');
  if (timeline) {
    const nums = (timeline.dataset.ranges || '0,0,1,2,3,5').split(',').map(Number);
    const fmt = new Intl.DateTimeFormat('es-CO', { day: 'numeric', month: 'short' });
    const dateAt = function (offset) {
      const d = new Date();
      d.setDate(d.getDate() + offset);
      return fmt.format(d);
    };
    const steps = timeline.querySelectorAll('.ppb-timeline__step');
    steps.forEach(function (step, i) {
      const min = nums[i * 2];
      const max = nums[i * 2 + 1];
      const label = step.querySelector('.ppb-timeline__date');
      if (!label) return;
      if (i === 0) {
        label.textContent = 'Hoy, ' + dateAt(min);
      } else if (min === max) {
        label.textContent = dateAt(min);
      } else {
        label.textContent = dateAt(min) + ' – ' + dateAt(max);
      }
      if (i === 0) step.classList.add('is-active');
    });
  }

  // --- Sticky bottom bar ---
  const stickyBarEl = document.querySelector('.ppb-sticky-bar');
  if (stickyBarEl) {
    const stickyCta = stickyBarEl.querySelector('.ppb-sticky-bar__cta');
    if (stickyCta) stickyCta.addEventListener('click', function () { if (form) form.requestSubmit(); });
    window.addEventListener('scroll', function () {
      const rect = root.getBoundingClientRect();
      const pastBuybox = rect.bottom < 0;
      stickyBarEl.classList.toggle('is-visible', pastBuybox);
    }, { passive: true });
  }
}
